module.exports = __webpack_public_path__ + "static/img/23_jiangyuliang.72c3af49.png";